module.exports = __webpack_public_path__ + "img/pic_04@2x.31f56164.png";